import React, { Component } from 'react';
import Utils from './Utils';
import { toAssetsExtUrl } from 'utils/assetsExtUrl';

class ImageOrLettersView extends Component {
    static defaultProps = {
        image: false
    };
    state = {
        image: this.props.image
    };
    handleImageError = () => this.setState({ image: false });
    render() {
        if (!this.state.image) {
            var letters = Utils.firstLetter(this.props.firstName) + Utils.firstLetter(this.props.lastName);
            return <div className="letters">{letters}</div>;
        }
        return (<img
            src={toAssetsExtUrl(this.props.image)}
            className={this.props.shape}
            width="100%"
            height="100%"
            onError={this.handleImageError}
        />);
    }
}

export default ImageOrLettersView;
